import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import {
  getPartyApi,
  getDataEntryStock,
  getStockInward,
  getDataEntryInwardStock,
  getMainStockInward,
  getUnitAPI,
  getUserApi,
} from "api";
import AsyncSelect from "react-select/async";
// import companyImage from '../../../public/images/dashboard-images/companyLogo.svg'

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";

class DataEntryOfficeStockList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      selectedPartyDetails: null,
      partyId: "",
      factoryId: "",
      orderId: "",
      graderUserId: "",
      fromDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      orderList: [],
      stockList: [],
      partyList: [],
      graderList: [],
    };
  }
  async componentDidMount() {
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    const grader = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000002",
    });

    if (grader && grader.data && Array.isArray(grader.data.users)) {
      this.setState({ graderList: grader.data.users });
    }
    const jangadList = await getDataEntryStock({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      graderUserId: this.state.graderUserId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    if (jangadList && jangadList.data) {
      this.setState(
        {
          orderList: jangadList.data.dataEntryStocks,
        },
        () => console.log(jangadList.data.dataEntryStocks)
      );
    }

    this.getStockList();
  }
  setParty = value => {
    this.setState({
      selectedPartyDetails: value,
    });
  };
  async getStockList() {
    const stockList = await getDataEntryStock({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      graderUserId: this.state.graderUserId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    this.setState({
      totalSize: stockList.data.count,
      stockList:
        stockList.data.dataEntryStocks.length == 0
          ? [
              {
                id: "0",
                jangad: {
                  cycle: 0,
                  weight: 0,
                  pieces: 0,
                  createdAt: "0",
                  factory: {
                    name: "0",
                  },
                },
                dataEntryGraderUser: {
                  name: "0",
                },
                mainJangad: {
                  name: "0",
                  party: {
                    name: "0",
                  },
                },
                stockDataEntryInWard: {
                  srNo: 0,
                  pieces: 0,
                },
                partyName: "0",
                weight: 0,
                pieces: 0,
                cycle: 0,
                createdAt: "",
              },
            ]
          : stockList.data.dataEntryStocks,
    });
  }
  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    this.setState({
      partyList: data.data.parties,
    });
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.partyCode, value: x.id };
        }),
      ];
    else return [];
  }
  async getJangadList(inputValue) {
    const data = await getDataEntryStock({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      graderUserId: this.state.graderUserId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: null,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      name: inputValue,
    });
    if (data && data.data) {
      this.setState(
        {
          orderList: data.data.dataEntryStocks,
        },
        () => console.log(this.state.dataEntryStocks)
      );
    }

    if (Array.isArray(data.data.dataEntryStocks))
      return [
        { label: "All", value: "" },
        ...data.data.dataEntryStocks.map(x => {
          return { label: x.mainJangad.name, value: x.mainJangad.id };
        }),
      ];
    else return [];
  }
  getOrderFilter() {
    return this.state.stockList.filter(
      x => this.state.partyId == x.mainJangad.partyId
    );
  }

  async getGraderList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000002",
    });
    if (data && data.data) {
      this.setState({
        graderList: data.data.users,
      });
    }

    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const promiseOptionsFiller = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getGraderList(inputValue));
        }, 0);
      });
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });
    this.columns1 = [
      {
        dataField: "sr",
        text: "#",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return (this.state.page - 1) * this.state.sizePerPage + rowIndex + 1;
        },
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "garderUser",
        text: `${this.props.t("Grader Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.dataEntryGraderUser.name;
        },
      },
      {
        dataField: "pieces",
        style:{width:"120px"},
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row.stockDataEntryInWards?.filter(x => x.ar).length;
          
          {
            return tot == row.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger pr-2">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style:{width:"130px"},
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row.stockDataEntryInWards?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.jangad.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <>
            {row.weight == 0 ? (
              ""
            ) : row.graderStatus == "A" ? (
              <Link
                to={{
                  pathname: "/data-entry-add-stock-inward",
                  query: {
                    isEdit: 3,
                    data: row,
                  },
                }}
              >
                <button className="py-2 px-2 ms-2 border-0 rounded">
                  <img src="images/dashboard-images/view.svg" />
                </button>
              </Link>
            ) : (
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/data-entry-add-stock-inward",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
                <Link
                  to={{
                    pathname: "/data-entry-add-stock-inward",
                    query: {
                      isEdit: 3,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 ms-2 border-0 rounded">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </div>
            )}
          </>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "manage stock";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Office Stock List")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start mb-3">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Office Stock List")}{" "}
                                </h3>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="fromDate"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="toDate"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Party Code")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.partyCode,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Grader Name")}
                                    </label>
                                    <AsyncSelect
                                      id="fillerId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            graderUserId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsFiller}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.graderList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if (e.value == "") {
                                              this.getJangadList(null);
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            value: x.mainJangad.id,
                                            label: x.mainJangad.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    columns={this.columns1}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    onTableChange={() => false}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(DataEntryOfficeStockList);
